export default __webpack_public_path__ + "ee2b84d9aace90af62ce015be6fefd91.png";